import { Toast } from "radix-ui";

const ToastDescription = ({ message }) => {
  return <Toast.Description className="text-sm">{message}</Toast.Description>;
};

export default ToastDescription;
